import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_these_additional_measures_in_place_rel'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_these_additional_measures_in_place_rel',
  name: 'Does the facility have any of these additional measures in place related to emergency drills?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'EMERGENCY_DRILLS_ARE_UNANNOUNCED',
      text: 'Emergency drills are unannounced',
      externalIds: [
        {
          id: 'hs-23--1-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EVERY_WORKER_EVACUATES',
      text: 'Every worker evacuates',
      externalIds: [
        {
          id: 'hs-23--1-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ALL_WORKERS_WITH_DISABILITIES_OR_SPECIAL_NEEDS_ARE_ASSISTED_BY_',
      text: 'All workers with disabilities or special needs are assisted by pre-assigned partners during emergency drill and in case of actual emergency',
      externalIds: [
        {
          id: 'hs-eme-10',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ALL_WORKERS_KNOW_THEIR_PRIMARY_EVACUATION_ROUTE_AND_THEIR_SECON',
      text: 'All workers know their primary evacuation route and their secondary route if the primary route is blocked',
      externalIds: [
        {
          id: 'hs-23--1-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_HAS_DESIGNATED_EMERGENCY_ASSEMBLY_AREAS_MEETING_POINTS',
      text: 'Facility has designated emergency assembly areas/meeting points which are large enough to safely accommodate all workers',
      externalIds: [
        {
          id: 'hs-23--1-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_MEET_AT_ASSEMBLY_MEETING_POINTS',
      text: 'Workers meet at assembly/meeting points',
      externalIds: [
        {
          id: 'hs-23--1-6x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ALL_POWER_IS_TURNED_OFF',
      text: 'All power is turned off',
      externalIds: [
        {
          id: 'hs-23--1-7x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'DOORS_AND_WINDOWS_ARE_CLOSED',
      text: 'Doors and windows are closed',
      externalIds: [
        {
          id: 'hs-23--1-8x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'STAFF_MONITORS_LEADS_ARE_PRESENT_TO_LISTEN_AND_WATCH_TO_ENSURE_',
      text: 'Staff monitors/leads are present to listen and watch to ensure all alarms work properly and all workers are evacuated as planned',
      externalIds: [
        {
          id: 'hs-23--1-9x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'THERE_IS_A_SYSTEM_IN_PLACE_TO_ACCOUNT_FOR_ALL_WORKERS_DURING_AN',
      text: 'There is a system in place to account for all workers during an emergency evacuation',
      externalIds: [
        {
          id: 'hs-23--1-10x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'THERE_IS_AN_ASSESSMENT_AFTER_THE_DRILL_TO_LEARN_HOW_TO_IMPROVE_',
      text: 'There is an assessment after the drill to learn how to improve the evacuation process',
      externalIds: [
        {
          id: 'hs-23--1-11x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EMERGENCY_DRILLS_ARE_DOCUMENTED_IN_A_WRITTEN_LOG',
      text: 'Emergency drills are documented in a written log',
      externalIds: [
        {
          id: 'hs-23--1-12x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-23--1-13x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'EMERGENCY_DRILLS_ARE_UNANNOUNCED',
                'EVERY_WORKER_EVACUATES',
                'ALL_WORKERS_WITH_DISABILITIES_OR_SPECIAL_NEEDS_ARE_ASSISTED_BY_',
                'ALL_WORKERS_KNOW_THEIR_PRIMARY_EVACUATION_ROUTE_AND_THEIR_SECON',
                'FACILITY_HAS_DESIGNATED_EMERGENCY_ASSEMBLY_AREAS_MEETING_POINTS',
                'WORKERS_MEET_AT_ASSEMBLY_MEETING_POINTS',
                'ALL_POWER_IS_TURNED_OFF',
                'DOORS_AND_WINDOWS_ARE_CLOSED',
                'STAFF_MONITORS_LEADS_ARE_PRESENT_TO_LISTEN_AND_WATCH_TO_ENSURE_',
                'THERE_IS_A_SYSTEM_IN_PLACE_TO_ACCOUNT_FOR_ALL_WORKERS_DURING_AN',
                'THERE_IS_AN_ASSESSMENT_AFTER_THE_DRILL_TO_LEARN_HOW_TO_IMPROVE_',
                'EMERGENCY_DRILLS_ARE_DOCUMENTED_IN_A_WRITTEN_LOG',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-eme-6',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 14930,
  sectionId: '2.2.9.4',
  impactArea: 'Emergency Preparedness',
  impactAreaId: 'EMERGENCY_PREPAREDNESS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
